module.exports = __webpack_public_path__ + "static/media/header_image_01.66c9e51b.jpg";